import { useEffect, useState } from "react";
import { continueRender, delayRender } from "remotion";

const HREF =
  "https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&family=Inter:wght@400;500;600;700;800&family=JetBrains+Mono:wght@400;500;700&display=swap";

/**
 * Loads the series fonts (Space Grotesk / Inter / JetBrains Mono) for both Studio
 * preview and server-side render. Blocks the render via delayRender() until the
 * stylesheet is in and document.fonts is ready, so frames never flash a fallback.
 * Render once as a sibling at the top of each composition.
 */
export const Fonts: React.FC = () => {
  const [handle] = useState(() => delayRender("coldcompute-fonts"));

  useEffect(() => {
    if (typeof document === "undefined") {
      continueRender(handle);
      return;
    }
    if (document.getElementById("coldcompute-fonts-link")) {
      continueRender(handle);
      return;
    }
    const link = document.createElement("link");
    link.id = "coldcompute-fonts-link";
    link.rel = "stylesheet";
    link.href = HREF;
    const done = () => {
      const ready = (document as Document & { fonts?: FontFaceSet }).fonts?.ready;
      if (ready) {
        ready.then(() => continueRender(handle)).catch(() => continueRender(handle));
      } else {
        continueRender(handle);
      }
    };
    link.onload = done;
    link.onerror = () => continueRender(handle);
    document.head.appendChild(link);
  }, [handle]);

  return null;
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
